import {
  getScheduleTimeFrame as publicGetScheduleTimeFrame,
  listScheduleTimeFrames as publicListScheduleTimeFrames,
} from './calendar-v3-schedule-time-frame-schedule-time-frames.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { onScheduleTimeFrameUpdated as publicOnScheduleTimeFrameUpdated } from './calendar-v3-schedule-time-frame-schedule-time-frames.public.js';

export const getScheduleTimeFrame: MaybeContext<
  BuildRESTFunction<typeof publicGetScheduleTimeFrame> &
    typeof publicGetScheduleTimeFrame
> = /*#__PURE__*/ createRESTModule(publicGetScheduleTimeFrame);
export const listScheduleTimeFrames: MaybeContext<
  BuildRESTFunction<typeof publicListScheduleTimeFrames> &
    typeof publicListScheduleTimeFrames
> = /*#__PURE__*/ createRESTModule(publicListScheduleTimeFrames);
/**
 * Triggered when a schedule's time frame is updated, indicating a new first or
 * last event or a change in the recurrence period, such as an extension or
 * reduction.
 */
export const onScheduleTimeFrameUpdated: BuildEventDefinition<
  typeof publicOnScheduleTimeFrameUpdated
> &
  typeof publicOnScheduleTimeFrameUpdated = createEventModule(
  publicOnScheduleTimeFrameUpdated
);

export {
  Status,
  PlacementType,
  DayOfWeek,
  ResolutionMethod,
  WebhookIdentityType,
} from './calendar-v3-schedule-time-frame-schedule-time-frames.universal.js';
export {
  ScheduleTimeFrame,
  ZonedDate,
  GetScheduleTimeFrameRequest,
  GetScheduleTimeFrameResponse,
  ListScheduleTimeFramesRequest,
  ListScheduleTimeFramesResponse,
  SitePropertiesNotification,
  SitePropertiesEvent,
  Properties,
  Categories,
  Locale,
  Address,
  AddressHint,
  GeoCoordinates,
  BusinessSchedule,
  TimePeriod,
  SpecialHourPeriod,
  Multilingual,
  SupportedLanguage,
  ConsentPolicy,
  Translation,
  ChangeContext,
  ChangeContextPayloadOneOf,
  PropertiesChange,
  SiteCreated,
  SiteCloned,
  Empty,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  ScheduleTimeFrameUpdatedEnvelope,
  GetScheduleTimeFrameOptions,
  ListScheduleTimeFramesOptions,
} from './calendar-v3-schedule-time-frame-schedule-time-frames.universal.js';
export {
  StatusWithLiterals,
  PlacementTypeWithLiterals,
  DayOfWeekWithLiterals,
  ResolutionMethodWithLiterals,
  WebhookIdentityTypeWithLiterals,
} from './calendar-v3-schedule-time-frame-schedule-time-frames.universal.js';
